<template>
  <div class="cargolist">

    <div class="southcargonn">
      <div class="bigbox">
        <div
          class="southcargo_top"
          v-for="(item, index) in datamsg"
          :key="index"
        >
          <div class="steer">计划号：{{ item.pno }}</div>
          <div class="southcargo_top_content">
            <ul>
              <li class="btned">
                <div class="divse">计划类型：{{ item.plantype }}</div>
                <div class="divse">货主：{{ item.customname }}</div>
                <div class="divse">代理：{{ item.fleetname }}分钟</div>
                <div class="divse">船名：{{ item.shipname }}度</div>
                <div class="divse">货物名称：{{ item.goodsname }}元</div>
                <div class="divse">作业场地：{{ item.destination }}</div>
              </li>
              <li class="btned">
                <div class="divse">作业垛位：{{ item.hwstr }}</div>
                <div class="divse">运费：{{ item.fleetCharge }}</div>
                <div class="divse">抢单车数：{{ item.carCount }}</div>
                <div class="divse">已通过车数：{{ item.passCarCount }}</div>
                <div class="divse">未通过车数：{{ item.unPasscarCount }}</div>
                <div class="divse">待审核车数：{{ item.unCheckCarCount }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="southcargo_bot">
          <div class="list_title">
            <div class="title-left">
              <span style="margin: 0 10px 0 0">车牌号</span>
              <input
                type="text"
                placeholder="请输入"
                style="width: 150px;"
                v-model="selectitem.plate"
              />
              <span style="margin: 0 10px 0 20px">车辆类型</span>
              <div class="select_box1">
                <m-select
                  :list="selectastrict"
                  :value="astrictval"
                  @input="chanval"
                  placeholder="请输入"
                ></m-select>
              </div>
              <span style="margin: 0 10px 0 20px">排放</span>
              <div class="select_box1">
                <m-select
                  :list="cityList"
                  :value="discharg"
                  @input="chanva"
                  placeholder="请输入"
                ></m-select>
              </div>
            </div>
            <div class="title-right">
              <button class="button1" @click="goback">返回</button>
              <button @click="searchdetail">查询</button>
              <button class="button1" @click="printList">导出</button>
            </div>
          </div>
          <div class="southcargo_bot_title"></div>
          <div class="tablebox">
            <el-table
              height="90%"
              :data="tablelist.list"
              style="width: 100%; "
              border
            >
              <el-table-column
                label="序号"
                type="index"
                width="50px"
              ></el-table-column>
              <el-table-column prop="plate" label="车牌号"> </el-table-column>
              <el-table-column prop="drivername" label="司机">
              </el-table-column>
              <el-table-column prop="telephone" label="联系方式">
              </el-table-column>
              <el-table-column prop="cartype" label="车辆类型">
                <template v-slot="res">
                  <span v-if="res.row.cartype == 1" style="text-align: center"
                    >新能源</span
                  >
                  <span v-if="res.row.cartype == 2" style="text-align: center"
                    >燃油车</span
                  >
                  <span v-if="res.row.cartype == 3" style="text-align: center"
                    >天然气车</span
                  >
                </template>
              </el-table-column>
              <el-table-column prop="discharge" label="排放"> </el-table-column>
              <el-table-column prop="truckTypecode" label="载重(kg)">
              </el-table-column>
              <el-table-column label="抢单时间">
                <template v-slot="res">
                  <span>{{ mydateFormat(res.row.mwitemdate, '年月日') }}</span>
                </template>
              </el-table-column>
              <el-table-column label="审核时间">
                <template v-slot="res">
                  <span>{{ mydateFormat(res.row.gmtModified, '年月日') }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="suttle" label="操作">
                <template v-slot="row">
                  <div v-if="row.status !== 65">
                    <span
                      style="color: #17B6A1"
                      class="el_spanfontstyle"
                      @click="butms(row.row)"
                      >确认</span
                    >
                    <span
                      style="color: #ef6b60"
                      class="el_spanfontstyle"
                      @click="items(row.row)"
                      >拒绝</span
                    >
                  </div>
                  <span style="color: #ef6b60" v-if="row.status === 65"
                    >拒绝</span
                  >
                  <span style="color: #b2b2b2" v-if="row.status === 11"
                    >已通过</span
                  >
                </template>
              </el-table-column> -->
            </el-table>
            <div class="paging">
              <el-pagination
                :page-size="selectitem.limit"
                layout="total,prev, pager,next, jumper"
                :total="tablelist.totalCount"
                :current-page="tablelist.page"
                @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <!-- <el-dialog
          title="通过提示"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose"
        >
          <span>是否通过{{ selectitem.plate }}的抢单？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="fn_accept_order">确 定</el-button>
          </span>
        </el-dialog> -->
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from '@/components/mTitle';
import mChebox from '@/components/mChebox.vue';
import columnper from '@/components/columnper';
import mSelect from '@/components/mSelect.vue';
import { printExcel } from '@/plugins/other.js';
export default {
  name: 'cargoinfo',
  data() {
    return {
      datamsg: [],
      pno: '',
      page: '',
      limit: '',
      datevalue: '', //开始结束时间
      selectitem: {
        page: 1, //当前页码
        limit: 20, //每页显示条数
        params: null,
        pno: '',
        status: '',
        endtime: '',
        discharge: '',
        order: '',
        plate: '',
        sidx: '',
        starttime: '',
        cartype: '',
      },
      cityList: [
        '柴油国三标准',
        '柴油国四标准',
        '柴油国五标准',
        '柴油国六标准',
        '国三天然气标准',
        '国四天然气标准',
        '国五天然气标准',
        '国六天然气标准',
        '新能源',
      ],
      tablelist: {},
      tabledata: [],
      timeout: null,
      astrictval: '',
      selectastrict: ['新能源', '燃油车', '天然气车'], //作业节点
      discharg: '', //排放
      session: {},
      dialogVisible: false,
      orderInfo: {},
    };
  },
  components: {
    mTitle,
    columnper,
    mChebox,
    mSelect,
  },
  created() {
    this.session = JSON.parse(sessionStorage.getItem('params')) || '';
    this.getinfomsg();
    this.selectitem.pno = this.session.pno;
  },
  methods: {
    butms(item) {
      this.selectitem.plate = item.plate;
      this.orderInfo = item;
      console.log(this.orderInfo);
      this.dialogVisible = true;
    },
    items(item) {},
    async confirmOrder(pass) {
      try {
        let url = '';
        if (pass) {
          url = 'driver/dispatchtruck/updatewebchatgo ';
        } else {
          url = 'driver/dispatchtruck/updatewebchatnotgo';
        }
        const { id, plate } = this.orderInfo;
        console.log(this.orderInfo, '1111111111');
        const data = {
          id,
          fleetname: '',
          plate,
        };
        console.log(data, '111');
        const res = await this.$http('api1', url, 'post', data);
        console.log(res, '-数值轴；');
        if (res.code !== 0) {
          this.$message.error(res.msg);
          throw res;
        }
        this.$message.success('操作成功');
        this.$emit('close');
        this.$emit('success');
      } catch (error) {
        console.log('error', error);
      }
    },
    // //拒绝订单
    async fn_resuse_order() {
      try {
        await this.$confirm('确定要拒绝此订单吗？', '抢单确认', {
          type: 'warning',
        });
        this.confirmOrder(false);
      } catch (error) {
        console.log('error', error);
      }
    },
    //接受订单
    async fn_accept_order() {
      try {
        this.confirmOrder(true);
      } catch (error) {
        console.log('error', error);
      }
    },

    handleClose() {
      this.dialogVisible = false;
    },
    //通过时间戳转换具体时间
    getSimpleDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? '0' + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s;
    },
    //返回按钮
    goback(){
      this.$router.go(-1)
    },
    // 详情列表
    async getinfomsg() {
      console.log(
        this.$route.params
      );
      const { data } = await this.$http(
        'api1',
        '/driver/dispatchtruck/fleetplanlist',
        'get',
        {
          pno: this.$route.params.pno || this.session.pno,
          page: this.$route.params.page || this.session.page,
          limit: this.$route.params.limit || this.session.limit,
        }
      );
      if (data.code != 0) return console.log('获取详情数据失败');
      this.datamsg = data.data.list;
      console.log(this.datamsg);
      this.gettablelist();
    },
    //查询
    searchdetail() {
      this.gettablelist();
    },
    chanval(e) {
      this.astrictval = e;
      switch (e) {
        case '新能源':
          this.$set(this.selectitem, 'cartype', 1);
          break;
        case '燃油车':
          this.$set(this.selectitem, 'cartype', 2);
          break;
        case '天然气车':
          this.$set(this.selectitem, 'cartype', 3);
          break;
      }
    },
    chanva(e) {
      this.discharg = e;
      switch (e) {
        case '柴油国三标准':
          this.$set(this.selectitem, 'discharge', 0);
          break;
        case '柴油国四标准':
          this.$set(this.selectitem, 'discharge', 1);
          break;
        case '柴油国五标准':
          this.$set(this.selectitem, 'discharge', 2);
          break;
        case '柴油国六标准':
          this.$set(this.selectitem, 'discharge', 3);
          break;
        case '国三天然气标准':
          this.$set(this.selectitem, 'discharge', 4);
          break;
        case '国四天然气标准':
          this.$set(this.selectitem, 'discharge', 5);
          break;
        case '国五天然气标准':
          this.$set(this.selectitem, 'discharge', 6);
          break;
        case '国六天然气标准':
          this.$set(this.selectitem, 'discharge', 7);
          break;
        case '新能源':
          this.$set(this.selectitem, 'discharge', 8);
          break;
      }
    },
    // 表格数据的获取
    async gettablelist() {
      this.selectitem.params = this.datamsg.params || null;
      const { data } = await this.$http(
        'api1',
        '/driver/dispatchtruck/listplandetail',
        'get',
        this.selectitem
      );
      console.log(data, '表格数据的获取');
      if (data.code != 0) return console.log('获取表格数据失败');
      this.tablelist = data.data;
    },
    exportlist() {
      if (!this.datamsg.pno) return '';
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async (_) => {
        const { data } = await this.$http(
          'api1',
          '/driver/dispatchtruck/exportPlanDispatchTruckList',
          'get',
          { pno: this.datamsg.pno }
        );
        if (!data) return;
        this.tabledata = data.data;
        this.$nextTick((_) => {
          this.$print(this.$refs.tablelist);
        });
      }, 300);
    },
    // 分页
    handleCurrentChange(index) {
      if (this.tablelist.totalCount < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.gettablelist();
    },
    //导出
    printList() {
      printExcel.call(
        this,
        '/api/replenish/log/exportEnergyLoglist',
        '充电记录列表',
        this.selectitem
      );
    },
    getsearch() {
      this.starttime = this.datevalue[0];
      this.endtime = this.datevalue[1];
      this.gettablelist(this.starttime, this.endtime);
    },
  },
};
</script>
<style lang="scss" scoped>
.cargolist {
  position: relative;
  height: 100%;
  .el_spanfontstyle {
    margin-left: 10px;
  }
  .select_box1 {
    display: inline-block;
    font-size: 80%;
    font-weight: 400;
    height: 38px;
    vertical-align: middle;
    margin-left: 10px;
    background-color: #f3f4f5;
    width: 150px;
  }
  .select_box {
    display: inline-block;
    font-size: 80%;
    font-weight: 400;
    height: 55px;
    vertical-align: middle;
    margin-left: 10px;
    .date {
      width: 150px;
    }
  }
  .btned {
    display: flex;
    .divse {
      margin-right: 6%;
    }
  }
  .southcargonn {
    position: absolute;
    top: 30px;
    bottom: 0;
    width: 100%;
    .bigbox {
      position: relative;
      box-sizing: border-box;
      height: 100%;
      .southcargo_top {
        position: relative;
        box-sizing: border-box;
        height: 29%;
        border-radius: 2px;
        background: #ffffff;
        padding: 10px;
        // overflow: auto;
        margin: 10px 0 10px 20px;
        border-radius: 20px;
        .steer {
          margin-left: 31px;
          margin-top: 5px;
        }
        .southcargo_top_content {
          position: absolute;
          top: 48px;
          bottom: 10px;
          left: 0;
          font-size: 80%;
          right: 10px;
          // display: flex;
          // justify-content: space-around;
          ul {
            line-height: 45px;
          }
          li {
            padding: 0;
            margin-right: 4%;
            list-style: none;
          }
        }
      }
      .southcargo_bot {
        position: absolute;
        box-sizing: border-box;
        top: 33%;
        margin-left: 20px;
        padding: 10px;
        border-radius: 20px;
        bottom: 0;
        width: 98%;
        overflow: auto;
        overflow: auto;
        background: #ffffff;
        .list_title {
          position: relative;
          padding-left: 10px;
          height: 45px;
          line-height: 55px;
          font-size: 80%;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title-left {
            input {
              padding-left: 10px;
              width: 160px;
              height: 30px;
              outline: none;
              border: none;
              background: #f3f4f5;
              border-radius: 2px;
            }
          }
          .title-right {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            button {
              width: 80px;
              height: 30px;
              background: #17b6a1;
              border-radius: 8px;
              border: none;
              color: #fff;
            }
            .button1 {
              width: 80px;
              height: 30px;
              background: #f5f6fa;
              border-radius: 8px;
              border: none;
              color: #17b6a1;
              margin-left: 20px;
            }
          }
        }
        .southcargo_bot_title {
          position: relative;
          box-sizing: border-box;
          height: 45px;
          font-size: 80%;
        }
        .tablebox {
          position: absolute;
          top: 80px;
          bottom: 0;
          width: 100%;
          overflow: hidden;
          .paging {
            position: absolute;
            width: 100%;
            bottom: 0;
            height: 30px;
            text-align: center;
          }
        }
      }
    }
  }
  .tableprint {
    display: none;
  }
}
</style>
